import { MuiColorInput, MuiColorInputProps } from "mui-color-input";

export interface IMuiColorInput extends MuiColorInputProps {}

const MuiColorInputFixed = MuiColorInput as any;

const ColorInput = (props: IMuiColorInput): JSX.Element => {
  return <MuiColorInputFixed {...props} />;
};

export default ColorInput;